<template>
  <div class="air-state-graph">

    <!-- 底座图标 -->
    <div class="absolute" style="left: 21px; top: 427px">
      <img src="./img/air-detail/ic_base.png" alt="">
    </div>

    <!-- 左边路径 -->
    <div style="position: absolute; left: 81px; top: 160px; width: 472px; height: 350px;">
      <svg width="472" height="350" viewBox="0 0 472 350" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M183.5 100.5H184.5V99.5V5.25C184.5 3.45507 185.955 2 187.75 2C189.545 2 191 3.45507 191 5.25V82C191 84.7614 193.239 87 196 87C198.761 87 201 84.7614 201 82V5C201 3.34315 202.343 2 204 2C205.657 2 207 3.34315 207 5V82C207 84.7614 209.239 87 212 87C214.761 87 217 84.7614 217 82V5C217 3.34315 218.343 2 220 2C221.657 2 223 3.34315 223 5V82C223 84.7614 225.239 87 228 87C230.761 87 233 84.7614 233 82V5C233 3.34315 234.343 2 236 2C237.657 2 239 3.34315 239 5V82C239 84.7614 241.239 87 244 87C246.761 87 249 84.7614 249 82V5C249 3.34315 250.343 2 252 2C253.657 2 255 3.34315 255 5V82C255 84.7614 257.239 87 260 87C262.761 87 265 84.7614 265 82V5C265 3.34315 266.343 2 268 2C269.657 2 271 3.34315 271 5V82C271 84.7614 273.239 87 276 87C278.761 87 281 84.7614 281 82V1H471V249H318C316.895 249 316 249.895 316 251V333C316 334.657 314.657 336 313 336C311.343 336 310 334.657 310 333L310 332L310 258L310 257C310 254.239 307.761 252 305 252C302.239 252 300 254.239 300 257V258V332V333C300 334.657 298.657 336 297 336C295.343 336 294 334.657 294 333V332V258V257C294 254.239 291.761 252 289 252C286.239 252 284 254.239 284 257V258V332V333C284 334.657 282.657 336 281 336C279.343 336 278 334.657 278 333V332V258V257C278 254.239 275.761 252 273 252C270.239 252 268 254.239 268 257V258V332V333C268 334.657 266.657 336 265 336C263.343 336 262 334.657 262 333V332V258V257C262 254.239 259.761 252 257 252C254.239 252 252 254.239 252 257V258V332V333C252 334.657 250.657 336 249 336C247.343 336 246 334.657 246 333V332V258V257C246 254.239 243.761 252 241 252C238.239 252 236 254.239 236 257V258V332V333C236 334.657 234.657 336 233 336C231.343 336 230 334.657 230 333V332V258V256.5C230 254.015 227.985 252 225.5 252C223.015 252 221 254.015 221 256.5V257.5V332V349.5H195.5V251V250H194.5H1V2.5H156V99.5V100.5H157H183.5Z"
          stroke="#C2CCFF" stroke-width="2" />
      </svg>
      <div class="air-state-arrow"></div>
      <div class="air-state-arrow second" ref="secondArrowRef"></div>
    </div>

    <!-- 膨胀阀 -->
    <div class="air-state-item flex-col-center"
      style="left: 64px; top: 240px; width: 39px; height: 57px;">
      <img src="./img/air-detail/ic_pzf.png">
      <span style="position: absolute; right: -24px; width: 20px; font-size: 14px;">膨胀阀</span>
    </div>

    <!-- 外风机 -->
    <div class="air-state-item flex-col-center" :class="{ 'is-alarm': state.telesignal?.fan_out_alarm }"
      style="left: 265px; top: 57px;">
      <img src="./img/air-detail/ic_arrow_down.png" style="rotate: 180deg;">
      <img src="./img/air-detail/ic_wind_ms.png">
      <span class="air-state-label" title="外风机">外风机</span>
    </div>

    <!-- 压缩机高低压开关 -->
    <div class="absolute" style="left: 522px; top: 210px">
      <img src="./img/air-detail/ic_ysj.png" alt="">
      <div style="width: 10px; height: 2px; background-color: #2F51FF; position: absolute; left: 21px; top: 11px;">
      </div>
      <span class="air-state-label break-word" title="压缩机高低压开关"
        style="left: auto; right: -110px; top: -10px; width: 60px;">压缩机高低压开关</span>
    </div>

    <!-- 压缩机 -->
    <div class="air-state-item flex-col-center"
      style="width: 50px; height: 50px; border-radius: 50%; left: 526px; top: 258px;">
      <div style="width: 2px; height: 20px; background-color: #2F51FF; rotate: 15deg; position: absolute; left: 15px;">
      </div>
      <div style="width: 2px; height: 20px; background-color: #2F51FF; rotate: -15deg; position: absolute; right: 15px;">
      </div>
      <span class="air-state-label" title="压缩机" style="left: 80px; top: 15px;">压缩机</span>
    </div>

    <!-- 过欠压模块 -->
    <div class="absolute" style="left: 450px; top: 275px; width: 42px; height: 26px; border: 1px solid #2F51FF">
      <div style="font-size: 12px; line-height: 1; text-align: center;">
        <div>U &lt;</div>
        <div>U &gt;</div>
      </div>
      <span class="air-state-label" title="过欠压模块">过欠压模块</span>
    </div>

    <!-- 加热器 -->
    <div class="air-state-item" :class="{ 'is-alarm': state.telesignal?.heater_alarm == 1 }"
      style="left: 284px; top: 528px">
      <img src="./img/air-detail/ic_zzz.png" alt="">
      <span class="air-state-label dark-text" title="加热器">加热器</span>
    </div>

    <!-- 外风机 网格 -->
    <div class="absolute" style="left: 298px; top: 419px;">
      <img src="./img/air-detail/ic_grid.png" alt="">
    </div>

    <!-- 内风机 网格 -->
    <div class="absolute" style="left: 264px; top: 170px;">
      <img src="./img/air-detail/ic_grid.png" alt="">
    </div>

    <!-- 冷凝器 -->
    <div style="position: absolute; top: 165px; left: 393px;">
      冷凝器
    </div>
    <div class="flex-col-center" style="position: absolute; left: 388px; top: 185px;">
      <span class="air-state-name" title="冷凝温度">冷凝温度</span>
      <div class="air-state-value">{{ state.telemeter?.evaporator_temp }}°C</div>
    </div>

    <!-- 蒸发器 -->
    <div style="position: absolute; top: 425px; left: 433px;">
      蒸发器
    </div>
    <div class="flex-col-center" style="position: absolute; top: 445px; left: 425px;">
      <span class="air-state-name" title="蒸发温度">蒸发温度</span>
      <div class="air-state-value">{{ state.telemeter?.condenser_temp }}°C</div>
    </div>

    <!-- 内风机 -->
    <div class="air-state-item flex-col-center" :class="{ 'is-alarm': state.telesignal?.fan_in_alarm }"
      style="left: 300px; top: 316px;">

      <div class="flex-col-center" style="position: absolute; top: -65px; left: -15px;">
        <span class="air-state-name" title="回风温度详情">回风温度</span>
        <div class="air-state-value">{{ state.telemeter?.cabinet_in_temp }}°C</div>
      </div>

      <div class="flex-col-center" style="position: absolute; top: -65px; left: 60px;">
        <span class="air-state-name" title="湿度">湿度</span>
        <div class="air-state-value">{{ state.telemeter?.humity }}%</div>
      </div>

      <img src="./img/air-detail/ic_arrow_down.png">
      <img src="./img/air-detail/ic_wind_ms.png">

      <span style="position: absolute; bottom: -22px; white-space: nowrap;">内风机</span>
    </div>

    <!-- 温度设置值 -->
    <div style="position: absolute; left: 140px; top: 280px;">
      <div class="air-value-set">
        <div class="truncated-text" title="制冷开启温度">制冷开启温度</div>
        <div class="ml-2 font-bold">{{ state.telemeter?.cool_start_temp }}℃</div>
      </div>
      <div class="air-value-set">
        <div class="truncated-text" title="制冷停止温度">制冷停止温度</div>
        <div class="ml-2 font-bold">{{ state.telemeter?.cool_stop_temp }}℃</div>
      </div>
      <div class="air-value-set">
        <div class="truncated-text" title="制热开启温度">制热开启温度</div>
        <div class="ml-2 font-bold">{{ state.telemeter?.heat_start_temp }}℃</div>
      </div>
      <div class="air-value-set">
        <div class="truncated-text" title="制热停止温度">制热停止温度</div>
        <div class="ml-2 font-bold">{{ state.telemeter?.heat_stop_temp }}℃</div>
      </div>
    </div>

    <!-- 传感器故障指示 -->
    <div v-if="state.telesignal?.cabin_in_sensor_fault == 1"
      style="position: absolute; left: 390px; top: 110px; border: 2px solid #2F51FF; color: #2F51FF; padding: 4px 8px;"
      :class="{ 'is-alarm': state.telesignal?.cabin_in_sensor_fault == 1 }">
      柜内传感器故障
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  state: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const secondArrowRef = ref(null)
let t
onMounted(() => {
  if (secondArrowRef.value) {
    t = setTimeout(() => {
      if (secondArrowRef.value) {
        secondArrowRef.value.style.opacity = 1
      }
    }, 10 * 1000);
  }
})

onUnmounted(() => {
  clearTimeout(t)
})

</script>

<style scoped lang="scss">
.air-state-graph {
  width: 700px;
  height: 700px;
  border: 1px solid var(--bg-color);
  margin-top: 16px;
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  
  --bg-color: #F5F5FE;

  @media (prefers-color-scheme: dark) {
    --bg-color: #3c3c3c;
  }

  .absolute {
    position: absolute;
  }

  .flex-col-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .break-word {
    word-wrap: break-word;
  }

  .air-state-item {
    position: absolute;
    border-radius: 6px;
    padding: 8px;
    box-shadow: 0px -1px 8.3px 0px #2F51FF73 inset;
    background: #fff;
  }

  @keyframes flashAnim {
    from {
      box-shadow: 0px -1px 8.3px 0px #ff0000d8 inset;
      background: rgb(255, 239, 239);
      color: #f00;
    }
    to {
      box-shadow: 0px -1px 8.3px 0px #2F51FF73 inset;
    }
  }

  .is-alarm {
    animation: flashAnim 0.5s infinite forwards alternate;
  }

  .air-state-name {
    font-size: 14px;
    color: rgba(46, 46, 46, 0.65);
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .air-state-value {
    padding: 2px 4px;
    min-width: 45px;
    text-align: center;
    border: 2px solid #2F51FF;
    color: #2F51FF;
  }

  .air-state-value::after {
    content: "";
    position: absolute;
    top: 46px;
    width: 2px;
    height: 20px;
    background: currentColor;
    left: 50%;
    transform: translateX(-50%);
  }

  .air-state-label {
    position: absolute;
    bottom: -22px;
    left: 50%;
    word-break: keep-all;
    transform: translateX(-50%);
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .air-value-set {
    display: flex;
    background-color: #DAE1FF80;
    padding: 2px 8px;
    margin-top: 4px;
  }
  
  .truncated-text {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      line-height: 24px;
  }
  
  .ml-2 {
      margin-left: 8px;
  }
  
  .font-bold {
      font-weight: bold;
      line-height: 24px;
  }

  .dark-text {
    @media (prefers-color-scheme: dark) {
        color: black;
    }
  }

  .air-state-arrow {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 10px;
    height: 10px;
    clip-path: polygon(100% 0, 100% 100%, 0 50%);
    background: #f00;
    offset-path: path('M183.5 100.5H184.5V99.5V5.25C184.5 3.45507 185.955 2 187.75 2C189.545 2 191 3.45507 191 5.25V82C191 84.7614 193.239 87 196 87C198.761 87 201 84.7614 201 82V5C201 3.34315 202.343 2 204 2C205.657 2 207 3.34315 207 5V82C207 84.7614 209.239 87 212 87C214.761 87 217 84.7614 217 82V5C217 3.34315 218.343 2 220 2C221.657 2 223 3.34315 223 5V82C223 84.7614 225.239 87 228 87C230.761 87 233 84.7614 233 82V5C233 3.34315 234.343 2 236 2C237.657 2 239 3.34315 239 5V82C239 84.7614 241.239 87 244 87C246.761 87 249 84.7614 249 82V5C249 3.34315 250.343 2 252 2C253.657 2 255 3.34315 255 5V82C255 84.7614 257.239 87 260 87C262.761 87 265 84.7614 265 82V5C265 3.34315 266.343 2 268 2C269.657 2 271 3.34315 271 5V82C271 84.7614 273.239 87 276 87C278.761 87 281 84.7614 281 82V1H471V249H318C316.895 249 316 249.895 316 251V333C316 334.657 314.657 336 313 336C311.343 336 310 334.657 310 333L310 332L310 258L310 257C310 254.239 307.761 252 305 252C302.239 252 300 254.239 300 257V258V332V333C300 334.657 298.657 336 297 336C295.343 336 294 334.657 294 333V332V258V257C294 254.239 291.761 252 289 252C286.239 252 284 254.239 284 257V258V332V333C284 334.657 282.657 336 281 336C279.343 336 278 334.657 278 333V332V258V257C278 254.239 275.761 252 273 252C270.239 252 268 254.239 268 257V258V332V333C268 334.657 266.657 336 265 336C263.343 336 262 334.657 262 333V332V258V257C262 254.239 259.761 252 257 252C254.239 252 252 254.239 252 257V258V332V333C252 334.657 250.657 336 249 336C247.343 336 246 334.657 246 333V332V258V257C246 254.239 243.761 252 241 252C238.239 252 236 254.239 236 257V258V332V333C236 334.657 234.657 336 233 336C231.343 336 230 334.657 230 333V332V258V256.5C230 254.015 227.985 252 225.5 252C223.015 252 221 254.015 221 256.5V257.5V332V349.5H195.5V251V250H194.5H1V2.5H156V99.5V100.5H157H183.5Z');
    animation: move 20s infinite linear reverse;
    z-index: 1;
  }

  .air-state-arrow.second {
    animation: wait 20s infinite linear, move 20s 10s infinite linear reverse;
    opacity: 0;
  }

  @keyframes wait {
    0% { opacity: 0; }
    50% { opacity: 0; }
    51% { opacity: 1; }
    100% { opacity: 1; }
  }

  @keyframes move {
    0% { offset-distance: 0%; }
    100% { offset-distance: 100%; }
  }
}
</style>
